import { render, staticRenderFns } from "./ConfigurazioneMedicoListPage.vue?vue&type=template&id=42503686"
import script from "./ConfigurazioneMedicoListPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMedicoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports